import gql from 'graphql-tag';

export default gql`
query adminBannerPlaces {
    adminBannerPlaces {
        id
        name
        type_id
    }
}
`;



// WEBPACK FOOTER //
// ./src/api/graphql/queries/adminBannerPlaces.ts